<template>
  <section class="conversation-gate">
    <strong>{{ gate.kind === 'input' ? '团队需要你的补充' : gate.kind === 'artifact' ? '文档内容与成品确认' : '当前步骤确认' }}</strong>
    <p>{{ gate.question }}</p>
    <template v-if="actionable">
      <agent-artifact-panel v-if="gate.kind === 'artifact'" :session-guid="message.taskGuid" runtime-engine="mastra" entry-mode="project" @jobs-change="$emit('changed')" />
      <template v-else>
        <el-input v-if="gate.kind === 'input'" v-model="answer" type="textarea" :rows="3" placeholder="填写后继续后台工作" maxlength="20000" />
        <el-button type="primary" size="small" :loading="busy" :disabled="gate.kind === 'input' && !answer.trim()" @click="decide(true)">{{ gate.kind === 'input' ? '补充并继续' : '确认并继续' }}</el-button>
        <el-button v-if="gate.kind !== 'input'" size="small" :disabled="busy" @click="decide(false)">拒绝</el-button>
      </template>
    </template>
    <small v-else>{{ message.payload.status === 'decision_recorded' ? '你的决定已保存，后台将继续处理' : '此确认事项已处理或失效，以最新状态为准' }}</small>
  </section>
</template>
<script>
import { decideProjectApproval, provideProjectInput } from '@/apis/project-team'
import { projectGateActionable } from '@/utils/project-conversation-state.mjs'
import AgentArtifactPanel from '@/views/app/layout-agent/components/agent-artifact-panel.vue'
export default {
  components: { AgentArtifactPanel }, props: { projectGuid: String, message: Object },
  data: () => ({ answer: '', busy: false }),
  computed: { gate() { return this.message.payload.gate || {} }, actionable() { return projectGateActionable(this.message.payload) } },
  methods: {
    async decide(approved) {
      if (!this.actionable || this.busy) return; this.busy = true
      try { const input = { projectGuid: this.projectGuid, runGuid: this.message.runGuid, gateId: this.gate.id, gateVersion: this.gate.version }
        await (this.gate.kind === 'input' ? provideProjectInput({ ...input, answer: this.answer.trim() }) : decideProjectApproval({ ...input, approved }))
        this.answer = ''; this.$emit('changed')
      } catch (e) { this.$message.error(e.message); this.$emit('changed') } finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.conversation-gate{margin-top:10px;background:#fffaf0;border:1px solid #ecd9b4;border-radius:12px;padding:20px}.conversation-gate p{white-space:pre-wrap;line-height:1.8}.conversation-gate .el-button{margin-top:12px}.conversation-gate small{color:#999}
</style>
